/** Interval between OCR status refetches while any record is still processing. */
export const OCR_RECORDS_POLL_INTERVAL_MS = 10000;

/**
 * Returns true if any row in the API records list still has OCR in progress.
 * Stops polling when every record's `record_meta_info.ocr.status` is not `"processing"`.
 */
export function recordsHaveOcrProcessing(
  records: readonly unknown[] | undefined | null
): boolean {
  if (!records?.length) return false;
  return records.some(
    (item) =>
      (item as { record_meta_info?: { ocr?: { status?: string } } })
        ?.record_meta_info?.ocr?.status === "processing"
  );
}
